import React from "react";
import PentestIcon1 from "../../assets/images/media/pentest_1.png";
import PentestIcon2 from "../../assets/images/media/pentest_2.svg";
import PentestIcon3 from "../../assets/images/media/pentest_3.svg";
import PentestIcon4 from "../../assets/images/media/pentest_4.png";
import PentestIcon5 from "../../assets/images/media/pentest_5.png";

const socialContent = [
  {
    classCol: "col-lg-3 col-md-4 col-6",
    boxClass: "bx-a",
    img: PentestIcon1,
    link: "#",
    animationDelay: "",
  },
  {
    classCol: "col-lg-2 col-md-4 col-6",
    boxClass: "bx-b",
    img: PentestIcon2,
    link: "#",
    animationDelay: "50",
  },
  {
    classCol: "col-lg-3 col-md-4 col-6",
    boxClass: "bx-c",
    img: PentestIcon3,
    link: "#",
    animationDelay: "100",
  },
  {
    classCol: "col-xl-2 col-lg-3 col-md-4 col-6",
    boxClass: "bx-d",
    img: PentestIcon4,
    link: "#",
    animationDelay: "150",
  },
  {
    classCol: "col-xl-2 col-lg-3 col-md-4 col-6",
    boxClass: "bx-e",
    img: PentestIcon5,
    link: "#",
    animationDelay: "200",
  }
];

const SocialTwo = () => {
  return (
    <div className="row justify-content-center">
      {socialContent.map((val, i) => (
        <div
          className={val.classCol}
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay={val.animationDelay}
          key={i}
        >
          <div className={`img-box ${val.boxClass}`}>
            <a href="#">
              <img src={`images/logo/${val.img}.png`} alt="logo" />
            </a>
          </div>
          {/* /.img-box */}
        </div>
      ))}

      {/* End .col */}
    </div>
  );
};

export default SocialTwo;
